import React from 'react';

interface RadioButtonProps {
  label: string;
  name: string;
  value: string | number;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
  required?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  className = '',
  disabled = false,
  required = false,
}) => {
  return (
    <div className={`radio-container ${className}`}>
      <input
        type="radio"
        name={name}
        id={`${name}-${value}`}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className="radio-input"
      />
      <label htmlFor={`${name}-${value}`} className="radio-label">
        {label}
      </label>
    </div>
  );
};

export default RadioButton;